import { render, staticRenderFns } from "./PointListDefaultLayout.vue?vue&type=template&id=03bbe202&scoped=true&"
import script from "./PointListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./PointListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bbe202",
  null
  
)

export default component.exports